const keys = ["employmentDocs.title", "employmentDocs.hint", "employmentDocs.version", "employmentDocs.none", "employmentDocs.link", "employmentDocs.unlink", "employmentDocs.linked", "employmentDocs.empty", "employmentDocs.unavailable", "employmentDocs.stale", "employmentDocs.previous", "employmentDocs.next"] as const;
const messages = {
  "it": [
    "Riferimento contrattuale",
    "Il collegamento non certifica firma o accettazione. Il PDF resta cifrato.",
    "Versione dei dati lavorativi",
    "Non collegato",
    "Collega",
    "Rimuovi collegamento",
    "Versione con decorrenza {date}",
    "Nessun contratto pubblicato.",
    "Documento o versione non disponibili. Aggiorna e verifica il dispositivo attivo.",
    "Il riferimento è cambiato. Aggiorna prima di riprovare.",
    "Precedenti",
    "Successivi"
  ],
  "es": [
    "Referencia contractual",
    "La relación no certifica firma ni aceptación. El PDF sigue cifrado.",
    "Versión de los datos laborales",
    "Sin vincular",
    "Vincular",
    "Retirar relación",
    "Versión vigente desde {date}",
    "No hay contratos publicados.",
    "Documento o versión no disponibles. Actualiza y comprueba el dispositivo activo.",
    "La referencia ha cambiado. Actualiza antes de reintentar.",
    "Anteriores",
    "Siguientes"
  ],
  "en": [
    "Contract reference",
    "The link does not certify signature or acceptance. The PDF remains encrypted.",
    "Employment details version",
    "Not linked",
    "Link",
    "Remove link",
    "Version effective from {date}",
    "No published contracts.",
    "Document or version unavailable. Refresh and check the active device.",
    "The reference changed. Refresh before retrying.",
    "Previous",
    "Next"
  ],
  "ro": [
    "Referință contractuală",
    "Legătura nu certifică semnătura sau acceptarea. PDF-ul rămâne criptat.",
    "Versiunea datelor de muncă",
    "Neasociat",
    "Asociază",
    "Elimină legătura",
    "Versiune valabilă din {date}",
    "Nu există contracte publicate.",
    "Documentul sau versiunea nu este disponibilă. Actualizează și verifică dispozitivul activ.",
    "Referința s-a schimbat. Actualizează înainte de a reîncerca.",
    "Anterioare",
    "Următoare"
  ],
  "ar": [
    "مرجع العقد",
    "لا يثبت الربط التوقيع أو القبول. يبقى ملف PDF مشفرًا.",
    "نسخة بيانات العمل",
    "غير مرتبط",
    "ربط",
    "إزالة الربط",
    "نسخة سارية من {date}",
    "لا توجد عقود منشورة.",
    "المستند أو النسخة غير متاحين. حدّث وتحقق من الجهاز النشط.",
    "تغيّر المرجع. حدّث قبل إعادة المحاولة.",
    "السابق",
    "التالي"
  ],
  "sq": [
    "Referenca e kontratës",
    "Lidhja nuk vërteton nënshkrimin ose pranimin. PDF-ja mbetet e shifruar.",
    "Versioni i të dhënave të punës",
    "Pa lidhje",
    "Lidh",
    "Hiq lidhjen",
    "Versioni në fuqi nga {date}",
    "Nuk ka kontrata të publikuara.",
    "Dokumenti ose versioni nuk është i disponueshëm. Rifresko dhe kontrollo pajisjen aktive.",
    "Referenca ka ndryshuar. Rifresko para se të provosh përsëri.",
    "Të mëparshmet",
    "Të ardhshmet"
  ],
  "uk": [
    "Посилання на договір",
    "Зв’язок не засвідчує підпис або згоду. PDF залишається зашифрованим.",
    "Версія трудових даних",
    "Не пов’язано",
    "Пов’язати",
    "Прибрати зв’язок",
    "Версія діє з {date}",
    "Опублікованих договорів немає.",
    "Документ або версія недоступні. Онови й перевір активний пристрій.",
    "Посилання змінилося. Онови перед повторною спробою.",
    "Попередні",
    "Наступні"
  ],
  "fr": [
    "Référence contractuelle",
    "Le lien ne certifie ni signature ni acceptation. Le PDF reste chiffré.",
    "Version des données de travail",
    "Sans lien",
    "Relier",
    "Retirer le lien",
    "Version applicable depuis le {date}",
    "Aucun contrat publié.",
    "Document ou version indisponible. Actualisez et vérifiez l’appareil actif.",
    "La référence a changé. Actualisez avant de réessayer.",
    "Précédents",
    "Suivants"
  ],
  "zh": [
    "合同关联",
    "关联不证明签名或接受。PDF 仍然加密。",
    "劳动信息版本",
    "未关联",
    "关联",
    "移除关联",
    "自 {date} 起生效的版本",
    "没有已发布的合同。",
    "文档或版本不可用。请刷新并检查有效设备。",
    "关联已更改。请刷新后重试。",
    "上一页",
    "下一页"
  ]
} as const;
export function employmentDocumentMessages(language:keyof typeof messages):Record<typeof keys[number],string> {
 return Object.fromEntries(keys.map((key,index)=>[key,messages[language][index]])) as Record<typeof keys[number],string>;
}
export function employmentDocumentMessage(error:unknown): 'employmentDocs.stale'|'employmentDocs.unavailable'|'common.error' {
 const message = error && typeof error==='object' && 'message' in error ? String(error.message) : '';
 if(message==='employment_stale')return 'employmentDocs.stale';
 if(['employment_document_invalid','employment_document_unavailable','device_key_not_active'].includes(message))return 'employmentDocs.unavailable';
 return 'common.error';
}
